import { lazy } from "react";
import { ZudokuConfig } from "zudoku";
import { ApiIdentitiesPage } from "../src/ApiIdentities";
import { Landingpage } from "../src/Landingpage";
import LogoutButton from "../src/Components/LogoutButton";

const isProduction = process.env.ZUDOKU_PUBLIC_NODE_ENV === "production";

const AppStoreWrapper = lazy(() => import("../src/index"));

let customNavItems;

customNavItems = [
  // Integrations Nav
  {
    type: "link",
    label: "Integrations",
    to: "/applications",
  },
  {
    type: "custom-page",
    path: "/applications/*",
    element: <AppStoreWrapper />,
  },
  {
    type: "custom-page",
    path: "/api-identities",
    element: <ApiIdentitiesPage />,
  },
  {
    type: "custom-page",
    path: "/logout",
    element: <LogoutButton />,
  },
] as const;

const allDocSections = [
  {
    type: "category",
    label: "Developer Portal",
    isDev: false,
    items: [
      "docs/overview",
      "docs/quickstart"
    ],
  },
  {
    type: "category",
    label: "Managing Integrations",
    isDev: false,
    items: [
      "docs/app-management/app-creation",
      "docs/app-management/basic-information",
      "docs/app-management/api-key",
      "docs/app-management/permissions",
    ],
  },
  {
    type: "category",
    label: "Webhook Events",
    isDev: false,
    items: [
      "docs/webhooks/overview",
      "docs/webhooks/managing-subscriptions",
      "docs/webhooks/event-payloads",
    ],
  },
  {
    type: "category",
    label: "Permitting & Licensing",
    isDev: false,
    items: [
      "docs/plc/overview",
      "docs/plc/access-control",
      "docs/plc/error-handling",
      "docs/plc/use-cases",
    ],
  },
  {
    type: "category",
    label: "Vendor Management",
    isDev: false,
    items: [
      "docs/vm/overview",
      "docs/vm/error-handling",
    ],
  },
  {
    type: "category",
    label: "Enterprise Asset Management",
    isDev: false,
    items: [
      "docs/eam/overview",
      "docs/eam/class-meta",
      "docs/eam/property-meta",
      "docs/eam/cookie-handling",
      {
        type: "doc",
        file: "docs/eam/data-types",
        label: "Data Types",
      },
      {
        type: "doc",
        file: "docs/eam/error-handling",
        label: "Exception Handling",
      },
    ],
  },
  {
    type: "category",
    label: "Platform Administration",
    isDev: false,
    items: [
      "docs/access-control/overview",
      "docs/access-control/user-groups-lifecycle",
      "docs/access-control/scim-integration",
      "docs/access-control/configuration-steps",
    ],
  },
  {
    type: "category",
    label: "Resources",
    isDev: false,
    items: [
      {
        type: "doc",
        file: "docs/changelog",
        label: "Changelog",
      },
    ],
  },
  {
    type: "category",
    label: "Internal Documentation",
    isDev: true,
    items: [
      "docs/internal/add-new-api",
      "docs/internal/add-quickstart-documentation",
      "docs/internal/external-api-spec",
      "docs/internal/producers",
      "docs/internal/portman-setup",
    ],
  },
] as const;

// Filter sections based on environment
const visibleDocSections = allDocSections.filter(
  (section) => !isProduction || !("isDev" in section && section.isDev)
);

export const navigation: ZudokuConfig["navigation"] = [
  {
    type: "custom-page",
    path: "/",
    element: <Landingpage />,
    label: "Home",
  },
  {
    type: "category",
    label: "Documentation",
    items: visibleDocSections,
  },
  {
    type: "link",
    label: "API Catalog",
    to: "/catalog",
  },
  ...customNavItems,
];
